<template>
	<div>
		<div>
			<ReInputSearchDropType 
				name="BigSearch"
				:placeholder="placeholder"
				:MinTxtLen="2"
				v-model="BigSearch"
				:objApiMethod="{obj:'NovoObj' ,flt:{name:'',type:'metro,distr'}}"
				strApiMethodKey="name"
				v-on:change="OnBigSearch"
			/>
		</div>
		<div>
			<el-tag
				v-for="tag in filterTags"
				:key="tag.param_id"
				size="small"
				:closable="true"
				:close-transition="false"
				@close="handleClose(tag)"
				:type="'primary'"
			>
				{{ tag.name }}
			</el-tag>
		</div>
	</div>
</template>

<script>
	import ReInputSearchDropType from 'src/our_modules/SearchSendObjects/ReInputSearchDropType.vue';
	import { Tag } from 'element-ui';

	export default {
		name: 'ReInputSearchDistrMetro',
		components: {
			ReInputSearchDropType,
			[Tag.name]: Tag,
		},
		props: {
			placeholder: {
				type: String,
				default: 'Поиск по метро, району, ЖК, застройщику',
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: {
				type: Object,
				default: function(){return {};}
			},
		},
		data () {
			return {
				ver: 1,
				BigSearch: {inputText: '', selectedVal:''},
				filterTags:[],
			}
		},
		computed: {

		},
		methods: {
			OnBigSearch(data){
				let masTmp = [];
				//пока костыли по мапингу для чекиста потребностей
				if(data.selectedType == 'dmetro')data.selectedType = 'metro_ids';
				if(data.selectedType == 'ddist')data.selectedType = 'district_ids';
				if(typeof this.value[data.selectedType] != 'undefined'){
					let strValue = this.translateTags(data);

					let tag = {name: `${this.value[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
					if(this.findTag(tag) != -1) this.filterTags.splice(this.findTag(tag), 1); // закрываем старый тег

					if(this.value[data.selectedType].value != ''){
						masTmp = this.value[data.selectedType].value.split(';');
					}
					masTmp.push(data.selectedVal);
					this.value[data.selectedType].value = masTmp.join(';');

					this.BigSearch.inputText='';
					strValue = this.translateTags(data);

					tag = {name: `${this.value[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
					this.filterTags.push(tag);
				}
			},
			handleClose(tag) {
				this.value[tag.param_id].value = '';
				this.filterTags.splice(this.findTag(tag), 1);
			},
			findTag(tag){
				for (let i = 0; i < this.filterTags.length; i++) {
					const elTag = this.filterTags[i];
					if(elTag.param_id == tag.param_id) return i;
				}
				return -1;
			},
			translateTags(data){
				let strValue = this.value[data.selectedType].value;
				let masValue = strValue.split(';');
				for (let i = 0; i < masValue.length; i++) {
					masValue[i] = this.$GVO.GetCat(this.value[data.selectedType].catalog,masValue[i]).name;
				}
				strValue = masValue.join(';');
				return strValue;
			},
			setOptTags(){ // отрисовка тегов
				this.filterTags = [];
				if (!this.$GVO.isEmpty(this.value)) {
					let masKeys = Object.keys(this.value);
					for (let i = 0; i < masKeys.length; i++) {	
						let element = this.getFilterDataElement(masKeys[i]);
						let bInTags = false;
						for (let iTag = 0; iTag < this.filterTags.length; iTag++) {
							if(this.filterTags[iTag].param_id == element.param_id){
								bInTags = true;
							}
						}
						if(!bInTags && element.value != ''){
							let tag = {name: `${element.tagText}: ${element.value}`, param_id: element.param_id};
							let strText = this.translateTags({selectedType: element.param_id});
							tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};

							if(tag != null ) this.filterTags.push(tag);
						}
					}
				}
			},
			getFilterDataElement(strKey){
				if (this.value.hasOwnProperty(strKey)){
					this.value[strKey].param_id = strKey;
					return this.value[strKey];
				}
			},
		},
		mounted(){
			this.$GVO.LoadCatPromise('CAT_DIST_TR').then((ret)=>{
				this.$GVO.LoadCatPromise('CAT_METRO').then((ret)=>{
					this.setOptTags();
				}).catch(errorRet => console.error(errorRet));
			}).catch(errorRet => console.error(errorRet));
		}
	}
</script>
<style scoped>

</style>
